'use strict';

wbApp.factory('userSvc', ['$resource', '$translate', '$q', '$timeout', 'repositorySvc', 'notificationSvc', 'tenantSettingSvc',
    function ($resource, $translate, $q, $timeout, repositorySvc, notificationSvc, tenantSettingSvc) {
        var User = $resource('/Api/Users/Get/:id', {}, {
            'query': { method: 'GET', isArray: true },
            'getCurrent': { method: 'GET', url: '/Api/Users/GetCurrent' },
            'update': { method: 'POST', url: '/Api/Users/Update' },
            'insert': { method: 'POST', url: '/Api/Users/Insert' },
            'delete': { method: 'POST', url: '/Api/Users/Delete' },
            'register': { method: 'POST', url: '/Api/Users/RegisterNewUser' },
            'getByID': { methof: 'GET', url: '/Api/Users/GetLookupID' },
            'getByIDFull': { methof: 'GET', url: '/Api/Users/Get' },
            'getConsentsInfo': { method: 'GET', isArray: true, url: '/Api/Users/GetConsentsInfo' },
            'anonymize': { method: 'POST', url: '/Api/Users/Anonymize' },
        });

        let users;
        let filteredUsers;
        
        function getConsentsInfo() {
            return repositorySvc.customGet('getConsentsInfo', User, { });
        }

        function createNew() {
            return {
                securityRoleID: 3,
                allowEmailContact: true,
                isNew: true,
                nationality: tenantSettingSvc.settings.defaultNationality
            };
        }

        function getAllAsync(refresh, excludeUnfinished) {
            let deferred = $q.defer();
            filteredUsers = filteredUsers ?? [];

            if (!users || !!refresh) {
                users = repositorySvc.get(User, {});
            }
            users.$promise.then(
                function (data) {
                    let data2 = excludeUnfinished
                        ? _.filter(data, function (u) {
                            return !String.prototype.isNullOrWhitespace(u.fullName);
                        })
                        : data;
                    filteredUsers.length = 0;
                    filteredUsers.push.apply(filteredUsers, data2);
                    return deferred.resolve(data2);
                },
                function (error) {
                    deferred.reject(error);
                });

            filteredUsers.$promise = deferred.promise;
            return filteredUsers;
        }

        function getAllBrief(refresh) {
            return $q(function (resolve, reject) {
                let allUsers = getAllAsync(refresh, true);
                allUsers.$promise.then(
                    function (data) {
                        resolve(_.map(data, function (u) {
                            return {
                                id: u.id + "",
                                fullName: u.fullName
                            };
                        }));
                    },
                    function (error) {
                        reject(error);
                    });
            });
        }

        function getByIDAsync(userId) {
            return repositorySvc.customGet('getByID', User, { userID: userId });
        }

        function getByIDFull(userId) {
            return repositorySvc.customGet('getByIDFull', User, { userID: userId });
        }

        function getCurrentAsync() {
            return repositorySvc.customGet('getCurrent', User);
        }

        function insert(data, successCallback, errorCallback) {
            return repositorySvc.insert(
                User,               // $resource
                filteredUsers,              // collection
                data,               // entity
                successCallback,
                errorCallback);
        }

        function update(data, successCallback, errorCallback, disableNotification) {
            return repositorySvc.update(
                User,            // $resource
                filteredUsers,           // collection
                data,            // entity
                successCallback,
                errorCallback,
                'id',
                disableNotification);
        }

        function remove(data, errorCallback) {
            return repositorySvc.remove(
                User,               // $resource
                filteredUsers,              // collection
                data,               // entity
                null,               // successCallback
                errorCallback);
        }

        //#endregion

        function registerAsync(user, students, loginDetails) {
            var deferred = $q.defer();
            var payload = {
                user: angular.copy(user),
                students: students,
                password: loginDetails.password
            };
            payload.user.userName = loginDetails.userName;

            User.register(payload, success, error);

            function success() {
                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_USER_REGISTERED'));
                deferred.resolve($translate.instant('TXT_ALERT_TITLE_USER_REGISTERED'));
            }

            function error(errorResult) {
                repositorySvc.defaultErrorHandler(errorResult, null);
                deferred.reject(errorResult);
            }

            return deferred.promise;
        }

        function anonymize(userID, anonymizeTaxDocuments, successCallback, errorCallback) {
            return repositorySvc.customPost(
                    'anonymize',
                    User,
                    {
                        id: userID,
                        anonymizeTaxDocuments: anonymizeTaxDocuments
                    },
                    successCallback,
                    errorCallback
                );
        }

        return {
            createNew: createNew,
            getAllAsync: getAllAsync,
            getCurrentAsync: getCurrentAsync,
            insert: insert,
            update: update,
            remove: remove,
            registerAsync: registerAsync,
            getByIDAsync: getByIDAsync,
            getByIDFull: getByIDFull,
            getConsentsInfo: getConsentsInfo,
            anonymize: anonymize,
            getAllBrief: getAllBrief
        }
    }]);